import { DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../widgets/Modal';
import Button from '../../../widgets/Button';
import { useMfaModalContext } from '../../../../shared/providers/MfaModalProvider';

import { MfaModalState } from '../../../../shared/constants/MFA';

import mfaVisual from '../../../../assets/icons/mfa/mfa-visuals.png';

function MFAEnabledModal({ enabled }: { enabled: boolean }) {
  const { setActiveModal, setPromptAlertModal, setAllowAccess } =
    useMfaModalContext();
  const { t } = useTranslation();

  return (
    <Modal
      open={enabled}
      handleClose={() => setPromptAlertModal(false)}
      modalClassName="max-w-[500px] px-[32px] py-[36px] pt-[44px] intl-2fa-modal"
    >
      <div className="mt-[51px] grid justify-center px-6 text-center">
        <img
          src={mfaVisual}
          className="m-auto mb-[26.66px] w-[214px]"
          alt="Mfa visuals"
        />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('MFA_ENABLED')}
        </DialogTitle>
        <span className="text-black-600 mb-[44px] text-sm">
          {t('MFA_ENABLED_SUBHEADER')}
        </span>
        <Button
          size="lg"
          className="mt-8"
          onClick={() => {
            setPromptAlertModal(false);
            setActiveModal(MfaModalState.NoModal);
            setAllowAccess({ login: true, layout: true });
          }}
        >
          {t('GOT_IT_CTA')}
        </Button>
      </div>
    </Modal>
  );
}

export default MFAEnabledModal;
